import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Grid,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { memo, useEffect, useState } from "react";
import { getData } from "../../../services/library";

const ReferenciasLaboralesModalRechazo = memo(
  ({
    open,
    onClose,
    mostrarAlertaTemporal,
    handleSubmit,
    setMotivo,
    motivo,
  }) => {
    const [motivosDesplegables, setMotivosDesplegables] = useState([]);
    const [idMotivoSeleccionado, setIdMotivoSeleccionado] = useState(undefined);

    useEffect(() => {
      getData("/SP_motivos_desplegables", (data) => {
        setMotivosDesplegables(Array.isArray(data) ? data : []);
      });
    }, []);

    const motivoSeleccionado = motivosDesplegables.find(
      (motivo) => motivo.id === idMotivoSeleccionado
    );

    useEffect(() => {
      setMotivo(motivoSeleccionado?.valor);
    }, [idMotivoSeleccionado, motivoSeleccionado]);

    const morivosSort = motivosDesplegables?.sort(function (a, b) {
      return a.valor.localeCompare(b.valor);
    });

    const handleClick = () => {
      if (!motivo) {
        mostrarAlertaTemporal(
          "Debe ingresar el motivo del rechazo de la referencia antes de enviar",
          "error"
        );
        return;
      }
      if (motivo?.length <= 8) {
        mostrarAlertaTemporal(
          "El motivo debe tener como minimo 8 caracteres",
          "error"
        );
        return;
      }
      handleSubmit();
    };
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography
              variant="h6"
              align="left"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              Rechazar referencia laboral
            </Typography>
          </DialogTitle>
        </Box>
        <DialogContent>
          <DialogContentText textAlign={"left"}>
            <Typography variant="body1" align="left" color="#1c1c1c">
              Debe indicar el motivo por el que se rechaza la referencia laboral
            </Typography>
          </DialogContentText>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel>
                Motivos recurrentes (Esta opcion reemplazara el texto de abajo)
              </InputLabel>
              <Select
                defaultValue={""}
                onChange={(e) => {
                  setIdMotivoSeleccionado(e.target.value);
                }}
                label="Motivos recurrentes"
                sx={{
                  maxHeight: "300px",
                  overflow: "auto",
                  "& .MuiMenu-paper": {
                    maxHeight: "300px", // Altura máxima del menú desplegable
                    overflowY: "auto", // Habilita el scroll si es necesario
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: "300px", // Asegura que el menú tenga scroll si el contenido es largo
                      overflowY: "auto",
                    },
                  },
                }}
              >
                {morivosSort?.sort().map((motivo) => (
                  <MenuItem
                    key={motivo.id}
                    value={motivo.id}
                    sx={{
                      maxWidth: "700px",
                      whiteSpace: "normal", // Permite que el texto use múltiples líneas
                      wordBreak: "break-word", // Rompe palabras largas
                    }}
                  >
                    {motivo.valor}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <TextField
            autoFocus
            margin="dense"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            id="motivo"
            label="Motivo"
            type="text"
            fullWidth
            multiline
            rows={4}
            inputProps={{ maxLength: 300 }}
          />
          <Typography variant="body2" color="textSecondary">
            {motivo?.length || 0} / 300 caracteres
          </Typography>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            direction="row"
            justifyContent="end"
            alignItems="center"
            gap={3}
            marginRight={2}
          >
            <Button
              variant="contained"
              onClick={onClose}
              style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
            >
              Volver
            </Button>
            <Button
              style={{ color: "#ffffff" }}
              type="submit"
              onClick={handleClick}
              variant="contained"
              color="primary"
            >
              Confirmar
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
);

export default ReferenciasLaboralesModalRechazo;
